import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
} from '@mui/material';

export const YesNo = ({
  grid,
  question,
  questionNumber,
  onChange,
  value,
  ...rest
}) => (
  <Grid
    item
    xs={grid || 12}
    className={`yes-no ${Number.isInteger(questionNumber) ? '' : 'offset'} ${
      rest.error ? 'error' : ''
    }`}
  >
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(value)}
            onChange={({ target: { checked } }) => onChange(String(checked))}
          />
        }
        label={question}
      />
      {rest.error ? <FormHelperText>{rest.helperText}</FormHelperText> : null}
    </FormGroup>
  </Grid>
);
